import React, { useState, useEffect } from 'react';
import { useFetch } from '../../../helpers/hooks/fetchData';
import styled from 'styled-components';
import { Modal } from '../../shared/modal/Modal';
import { Button } from '../../shared/button/Button';

export const DeleteCategory = ({ category, showModal, setShowModal }) => {
  const [payload, setPayload] = useState({
    title: '',
  });
  const { data, hasError } = useFetch(payload);
  const errorText = 'Error deleting category';

  useEffect(() => {
    if (data) {
      setShowModal(false);
      return window.location.reload();
    }
  }, [data, setShowModal]);

  const deleteCategory = () => {
    if (!category || !category._id) {
      return false;
    }
    setPayload({
      endpoint: '/api/omega/categories/' + category._id,
      method: 'delete',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
  };

  return (
    <>
      {showModal && (
        <Modal
          show={showModal}
          handleExit={setShowModal}
          title='Delete category'
          width={'40rem'}
        >
          {!hasError && (
            <>
              <Label>Are you sure you want to delete this category?</Label>
              <Margin />
              <Button
                type='submit'
                onClick={deleteCategory}
                primary
                text='Delete'
              />

              <PaddingBetweenButton />
              <Button
                onClick={() => setShowModal(false)}
                secondary
                text='Cancel'
                type='reset'
              />
            </>
          )}
          {hasError && (
            <>
              <ErrorMessage>{errorText}</ErrorMessage>
              <Button secondary onClick={() => setShowModal(false)} text='OK' />
            </>
          )}
        </Modal>
      )}
    </>
  );
};

const Label = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
`;
const ErrorMessage = styled.div`
  color: red;
  font-size: 2rem;
  text-align: center;
  margin-bottom: 30px;
`;

const Margin = styled.div`
  height: ${(props) => props.theme.spacing.small};
`;
const PaddingBetweenButton = styled.div`
  height: ${(props) => props.theme.spacing.standard};
`;
